function locationRequest() {
  fetch('https://us-central1-functions-358315.cloudfunctions.net/location')
  .then(response => response.json())
  .then(data => {
    const country = data.countryCode;
    if(country == 'IT' || country == 'BE' || country == 'DK' || country == 'FR' || country == 'DE' || country == 'NL' || country == 'PL' || country == 'ES' || country == 'LU' ){
      window.location.href = "https://michelelopriore.it/";
    }
  })
  .catch(error => console.error('Error fetching data:', error));
}

locationRequest();